import crypto from 'crypto-js'
import { getEnv } from '../platform'

export function encrypt(text: string): string {
  return crypto.AES.encrypt(text, getEnv().encryptionKey || '').toString()
}

export function decrypt(cipherText: string): string {
  const bytes = crypto.AES.decrypt(cipherText, getEnv().encryptionKey || '')
  return bytes.toString(crypto.enc.Utf8)
}
